export default {
  additionalServices: 'Doplnkové služby',
  capacity: 'Kapacita',
  equipment: 'Vybavenie',
  equipmentAndServices: 'Vybavenie a služby',
  focusAnimals: 'Zameranie na zvieratá',
  info: 'Údaje',
  roomsCount: 'Počet izieb',
  roomsTypes: 'Typy izieb',
  service: 'Služba | Služby',
  serviceName: 'Meno služby',
  slug: 'Krátky a výstižný názov služby (bez diakritiky)',
  id: {
    1: 'Ubytovanie',
    2: 'Ambulancia',
    3: 'Salón',
    4: 'Výcvik',
    5: 'Venčenie',
    6: 'Útulok'
  },
  type: {
    ambulance: 'Ambulancia',
    hotel: 'Ubytovanie',
    salon: 'Salón',
    trainer: 'Výcvik',
    walking: 'Venčenie',
    shelter: 'Útulok'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/sk/service.js